import { type QuickMdState } from '@/app/store'

/** The whole flags object. Only the Dev Tools panel wants this — everything else selects one flag. */
export const selectFlags = (state: QuickMdState) => {
  return state.flags.flags
}

export const selectMergeDuplicateAccounts = (state: QuickMdState) => {
  return state.flags.flags.merge_duplicate_accounts
}

export const selectPharmacySearchDaw = (state: QuickMdState) => {
  return state.flags.flags.pharmacy_search_daw
}

export const selectProgramVisitBadgeFlag = (state: QuickMdState) => {
  return state.flags.flags.program_visit_badge_admin
}
